// extracted by mini-css-extract-plugin
module.exports = {"clickable":"SortableTable_clickable__3wpqJ"};